import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import { Field, Form } from "react-final-form";
import { withRouter } from 'react-router-dom';
import Moment from 'moment';
import swal from 'sweetalert2';
import { addError } from 'actions';
import { createAssignment, getTaskDetails, setActiveAssignment, updateAssignment } from 'actions/assignments';
import { getPlanDetails, getPlansBySectionId, setActivePlan, clearSectionPlansFromStore } from 'actions/plans';
import { createAssessmentBlock, getBlocksByReference, updateAssessmentBlock, updateBlocksOnReference, deleteBlock } from 'actions/blocks';
import { clearSelectedSections, getSection, toggleSelectedSection, setActiveSection } from 'actions/sections';
import { getScheduleForUser, getScheduleItems, clearSearchedSchedules } from 'actions/schedule';
import { getRootUrl } from 'helpers/url';
import DatePickerFromTo from '../Partials/DatePickerFromTo';
import GroupSelector from '../Partials/GroupSelector';
import InvalidGroupNotice from '../Partials/InvalidGroupNotice';
import TeacherAdjustments from 'containers/AdditionalAdjustments/Display/TeacherAdjustments';
import AssignmentTaskSelect from 'components/List/AssignmentTaskSelect';
import Modal from 'containers/Modals/Modal';
import DatePicker from 'react-datepicker';
import Select from "components/Inputs/select";
import Upload from "components/Inputs/upload";
import AttachedDocuments from "components/Presentation/Documents/AttachedDocuments";
import BlockAssessments from "components/BlockAssessments";
import { Expandable, Spinner } from 'UI';
import { Editor, TimePicker } from 'UI/Inputs';
import { Button, Checkbox } from '@haldor/ui';
import CustomSelector from '../Partials/CustomSelector';

var AssignmentForm = /*#__PURE__*/function (_Component) {
  _inherits(AssignmentForm, _Component);

  var _super = _createSuper(AssignmentForm);

  function AssignmentForm(props) {
    var _props$initialValues, _props$initialValues3, _props$initialValues5, _props$initialValues6, _props$initialValues$, _props$initialValues7;

    var _this;

    _classCallCheck(this, AssignmentForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (typeof value != 'undefined' && value != '' && value != null) {
        if (value.length > 199) {
          // Field failed validation, return error for this field (String)
          return _this.props.translate('field-max-200-chars');
        } // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string and not over 200 characters


        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate('field-needs-input');
    });

    _defineProperty(_assertThisInitialized(_this), "requireAssignmentTasks", function (values) {
      var _this$props$initialVa;

      if (values == null || values.length == 0) {
        return _this.props.translate('field-needs-input');
      }

      if (!_this.props.editView) {
        var countTaskAssignees = 0;
        values.forEach(function (element) {
          var _element$students;

          if (((_element$students = element.students) === null || _element$students === void 0 ? void 0 : _element$students.length) > 0) {
            var _element$students2;

            countTaskAssignees += (_element$students2 = element.students) === null || _element$students2 === void 0 ? void 0 : _element$students2.length;
          }
        });

        if (countTaskAssignees > 0) {
          return undefined;
        }

        return _this.props.translate('field-needs-input');
      } //handle validation for groups if enabled


      if ((_this$props$initialVa = _this.props.initialValues) !== null && _this$props$initialVa !== void 0 && _this$props$initialVa.groupEnabled) {
        var _countTaskAssignees = 0;
        values.forEach(function (element) {
          var _element$students3;

          if (((_element$students3 = element.students) === null || _element$students3 === void 0 ? void 0 : _element$students3.length) > 0) {
            var _element$students4;

            _countTaskAssignees += (_element$students4 = element.students) === null || _element$students4 === void 0 ? void 0 : _element$students4.length;
          }
        });

        if (_countTaskAssignees > 0) {
          return undefined;
        }

        return _this.props.translate('field-needs-input');
      }

      var studentsArr = []; //check how many of the task has markedForDeletion

      var getDeleted = values === null || values === void 0 ? void 0 : values.filter(function (x) {
        return x === null || x === void 0 ? void 0 : x.markedForDeletion;
      }); //handle groupassignments

      values.forEach(function (element) {
        studentsArr = [].concat(_toConsumableArray(studentsArr), _toConsumableArray(element.students));
      });

      if (getDeleted.length === studentsArr.length) {
        return _this.props.translate('field-needs-input');
      }

      return undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      if (_this.props.cloneView) {
        _this.setState({
          loading: true
        });
      }

      _this.props.clearSectionPlansFromStore();
    });

    _defineProperty(_assertThisInitialized(_this), "getToggleLesson", function (data) {
      var obj = {};
      data.forEach(function (element) {
        obj = _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, element.id, true));
      });
      return obj;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var _this$props$initialVa2, _this$props$initialVa3;

      if (_this.props.groupid != null) {
        var sectionId = _this.props.groupid;

        var find = _this.props.sections.find(function (t) {
          return t.id == sectionId;
        });

        if (find == null) {
          _this.setState({
            sectionId: 0
          });
        } else {
          _this.setState({
            sectionId: sectionId,
            loading: true
          }, function () {
            var promises = [];
            promises.push(_this.props.getPlansBySectionId(sectionId));
            promises.push(_this.props.getSection(sectionId));

            if (_this.props.cloneView) {
              promises.push(_this.props.getTaskDetails(_this.props.task.id));
            }

            Promise.all(promises).then(function () {
              _this.setState({
                loading: false
              });

              _this.props.toggleSelectedSection(_this.props.section);
            });
          });
        }
      }

      if (_this.props.planid != null) {
        _this.props.getPlanDetails(_this.props.planid);
      }

      if (_this.props.cloneView) {
        _this.setState({
          loading: true
        });

        _this.props.getTaskDetails(_this.props.task.id).then(function () {
          _this.setState({
            loading: false
          });
        });
      }

      if (((_this$props$initialVa2 = _this.props.initialValues) === null || _this$props$initialVa2 === void 0 ? void 0 : (_this$props$initialVa3 = _this$props$initialVa2.relationships) === null || _this$props$initialVa3 === void 0 ? void 0 : _this$props$initialVa3.length) > 0) {
        var promises = [];

        _this.props.initialValues.relationships.forEach(function (element) {
          promises.push(_this.props.getScheduleItems(element.calendarEventId));
        });

        Promise.all(promises).then(function () {
          _this.setState({
            selectedLesson: _this.props.connectedLessons,
            lesson: _this.props.connectedLessons,
            toggleLesson: _this.getToggleLesson(_this.props.connectedLessons)
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "fixDescription", function (html) {
      html = html.replace(/&lt;/g, '<');
      html = html.replace(/&gt;/g, '>');
      html = html.replace(/\<\/b\>/gi, ' </b>');
      html = html.replace(/\<\/i\>/gi, ' </i>');
      html = html.replace(/\<\/a\>/gi, ' </a>');
      html = html.replace(/\<\/p\>/gi, ' </p>');
      return html;
    });

    _defineProperty(_assertThisInitialized(_this), "handleStatus", function (value) {
      _this.setState({
        status: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDisplayInSchedule", function (event) {
      event.preventDefault();

      _this.setState({
        createEvent: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      var _this$state$published;

      _this.setState({
        createEvent: false,
        tempPublishDate: (_this$state$published = _this.state.published) !== null && _this$state$published !== void 0 ? _this$state$published : _this.inititalPublished
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleLessons", function (checked, lessonObj) {
      _this.setState(function (prevState) {
        return {
          selectedLesson: checked ? [].concat(_toConsumableArray(prevState.selectedLesson), [lessonObj]) : prevState.selectedLesson.filter(function (x) {
            return x.id != lessonObj.id;
          }),
          toggleLesson: checked ? _objectSpread(_objectSpread({}, prevState.toggleLesson), {}, _defineProperty({}, lessonObj.id, true)) : _objectSpread(_objectSpread({}, prevState.toggleLesson), {}, _defineProperty({}, lessonObj.id, false))
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "filterLesson", function (data) {
      var sortByStartTime = function sortByStartTime(a, b) {
        return Moment(a.startTime).diff(b.startTime);
      };

      if (_this.state.selectedLesson.length > 0) {
        var filter = data.filter(function (item) {
          return !_this.state.selectedLesson.find(function (f) {
            return f.id === item.id;
          });
        });
        return filter.concat(_this.state.selectedLesson).sort(sortByStartTime);
      }

      return data.sort(sortByStartTime);
    });

    _defineProperty(_assertThisInitialized(_this), "fetchLesson", function () {
      if (!_this.state.allowFetch) {
        return;
      } //dont fetch if both start and end date is same


      var start = _this.state.dateStart;
      var end = _this.state.dateEnd;
      var diff = end.diff(start, 'minutes');

      if (diff === 0) {
        return;
      }

      _this.setState({
        isFetchingLesson: true
      });

      if (_this.state.dateStart && _this.state.dateEnd) {
        _this.props.getScheduleForUser(_this.props.user.id, Moment(_this.state.dateStart).utc().set({
          second: 0,
          millisecond: 0
        }).toISOString(), Moment(_this.state.dateEnd).utc().set({
          second: 0,
          millisecond: 0
        }).toISOString()).then(function () {
          _this.setState({
            lesson: _this.filterLesson(_this.props.usersSchedule[_this.props.user.id]),
            isFetchingLesson: false,
            allowFetch: false
          });
        })["catch"](function (e) {
          _this.setState({
            isFetchingLesson: true
          });
        });
      } else {
        var startTime = Moment().utc().set({
          hour: 0,
          minute: 0,
          second: 0
        }).toISOString();
        var endTime = Moment().utc().set({
          hour: 23,
          minute: 59,
          second: 59
        }).toISOString();

        _this.props.getScheduleForUser(_this.props.user.id, startTime, endTime).then(function () {
          _this.setState({
            lesson: _this.filterLesson(_this.props.usersSchedule[_this.props.user.id]),
            isFetchingLesson: true,
            allowFetch: false
          });
        })["catch"](function (e) {
          _this.setState({
            isFetchingLesson: true
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDisplayDate", function (date) {
      _this.setState({
        tempPublishDate: Moment(date)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmitDisplayDate", function () {
      _this.setState({
        published: _this.state.tempPublishDate,
        createEvent: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      var initialValues = _this.props.initialValues;
      var _this$state = _this.state,
          dateStart = _this$state.dateStart,
          dateEnd = _this$state.dateEnd,
          attachedFiles = _this$state.attachedFiles,
          sectionId = _this$state.sectionId,
          published = _this$state.published;

      if (sectionId == 0 || sectionId == "") {
        return new Promise(function (resolve) {
          return resolve(1);
        });
      }

      return new Promise(function (resolve) {
        var assessmentBlocks = [];
        var deletedBlocks = [];
        var isEditing = _this.props.editView;

        if (values.groupEnabled == null || _this.props.cloneView) {
          values.groupEnabled = true;
        }

        if (_this.state.selectedLesson.length > 0) {
          var relation = [];

          _this.state.selectedLesson.map(function (items) {
            var obj = {
              CalendarEventId: items.id,
              ReferenceType: 'ASSIGNMENT',
              ReferenceId: 0
            };
            relation.push(obj);
          });

          values.relationships = relation;
        } else {
          values.relationships = [];
        }

        values.startDate = dateStart;
        values.dueDate = dateEnd;
        values.sectionId = parseInt(sectionId);

        if (values.status === 'ASSIGNMENT_DRAFT') {
          values.published = '0001-01-01T00:00:00';
          values.status = _this.state.status;
        } else {
          values.published = published;
        }

        values.attachedFiles = _this.state.attachedFiles;

        if (values.status == null) {
          values.status == 'ASSIGNMENT_OPEN';
        }

        if (values.assessmentBlocks != null) {
          assessmentBlocks = _toConsumableArray(values.assessmentBlocks);
        }

        if (values.assessmentType == null) {
          values.assessmentType = 'TEACHER';
        }

        if (_this.state.newDocuments.length > 0) {
          values.attachedFiles = [].concat(_toConsumableArray(values.attachedFiles), _toConsumableArray(_this.state.newDocuments));
        }

        values.plans = null;

        if (typeof values.status === 'undefined') {
          values.status = _this.state.status;
        }

        if (isEditing) {
          values.status = _this.state.status;
        }

        if (initialValues != null && initialValues.assessmentBlocks != null) {
          deletedBlocks = _toConsumableArray(initialValues.assessmentBlocks).filter(function (block) {
            return !assessmentBlocks.find(function (_bl) {
              return _bl.id == block.id;
            }) && !values.assessmentBlocks.find(function (_bl) {
              return _bl.id == block.id;
            });
          });
        }

        delete values.assessmentBlocks;

        var that = _assertThisInitialized(_this);

        if (isEditing && _this.props.cloneView == false) {
          values.workspace = initialValues.workspace;

          _this.props.updateAssignment(values).then(function () {
            var promises = [];

            if (deletedBlocks.length > 0) {
              deletedBlocks.forEach(function (block) {
                var deletePromise = new Promise(function (resolve) {
                  _this.props.deleteBlock(block.id).then(function () {
                    resolve(1);
                  });
                });
                promises.push(deletePromise);
              });
            }

            assessmentBlocks.forEach(function (block) {
              promises.push(new Promise( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
                  var initialBlock;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          initialBlock = _this.props.initialValues.assessmentBlocks.find(function (b) {
                            return b.id == block.id;
                          });

                          if (!(initialBlock != null)) {
                            _context.next = 6;
                            break;
                          }

                          _context.next = 4;
                          return _this.props.updateAssessmentBlock(block, initialBlock);

                        case 4:
                          _context.next = 8;
                          break;

                        case 6:
                          _context.next = 8;
                          return _this.props.createAssessmentBlock(block, initialValues.id, 'ASSIGNMENT');

                        case 8:
                          resolve(1);

                        case 9:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()));
            });
            Promise.all(promises).then(function () {
              that.props.addError(that.props.translate("changes-saved"), "info");
              that.props.onAbort(true, true, true);
              resolve(true);
            });
          });
        } else {
          if (_this.props.cloneView) {
            values.documentTemplates = null;
            values.assignmentDocuments = null;
          }

          _this.props.createAssignment(values).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
            var starttime, promises;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    if (_this.props.onSubmit) {
                      starttime = Moment(values.dueDate).utc().format();

                      _this.props.onSubmit(starttime);
                    }

                    if (!(_this.state.planid != 0)) {
                      _context3.next = 4;
                      break;
                    }

                    _context3.next = 4;
                    return new Promise( /*#__PURE__*/function () {
                      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
                        var blocks;
                        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                          while (1) {
                            switch (_context2.prev = _context2.next) {
                              case 0:
                                _context2.next = 2;
                                return _this.props.getBlocksByReference(_this.state.planid, 'PLAN');

                              case 2:
                                blocks = [];

                                if (_this.props.planBlocks != null && _this.props.planBlocks.length > 0) {
                                  blocks = _toConsumableArray(_this.props.planBlocks);
                                  blocks.forEach(function (block) {
                                    if (block.type == 'Haldor.Blocks.Assignment') {
                                      if (block.resources != null) {
                                        var resources = [];
                                        block.resources.forEach(function (resource) {
                                          resources.push({
                                            id: resource.id,
                                            '@odata.type': resource['@odata.type']
                                          });
                                        });
                                        block.resources = resources;
                                      }
                                    }

                                    block['_Resources'] = null;
                                    return block;
                                  });
                                }

                                blocks.push({
                                  type: 'Haldor.Blocks.Assignment',
                                  title: '',
                                  value: '',
                                  sortorder: blocks.length,
                                  id: 0,
                                  resources: [{
                                    '@odata.type': 'haldor.assignment.block.assignment',
                                    id: _this.props.newAssignment.id
                                  }]
                                });
                                _context2.next = 7;
                                return _this.props.updateBlocksOnReference(blocks, _this.state.planid, 'PLAN');

                              case 7:
                                resolve(1);

                              case 8:
                              case "end":
                                return _context2.stop();
                            }
                          }
                        }, _callee2);
                      }));

                      return function (_x2) {
                        return _ref3.apply(this, arguments);
                      };
                    }());

                  case 4:
                    promises = [];
                    assessmentBlocks.forEach(function (block) {
                      if (_this.props.cloneView) {
                        block.resources.map(function (resource) {
                          resource.originId = resource.id;
                          resource.id = 0;
                          return resource;
                        });
                      }

                      promises.push(new Promise(function (resolve) {
                        _this.props.createAssessmentBlock(block, _this.props.newAssignment.id, 'ASSIGNMENT').then(function () {
                          resolve(1);
                        });
                      }));
                    });
                    Promise.all(promises).then(function () {
                      resolve(true);

                      if (_this.props.dontRedirect) {
                        that.props.onAbort(true);
                        return;
                      }

                      if (_this.props.onCreated != null) {
                        _this.props.onCreated(_this.props.newAssignment);
                      } else {
                        if (_this.props.newAssignment != null && !_this.props.dontRedirect) {
                          var id = _this.props.newAssignment.id;

                          if (_this.props.cloneView) {
                            window.location = "".concat(getRootUrl(), "assignment/").concat(id);
                          } else {
                            _this.props.history.push("".concat(getRootUrl(), "assignment/").concat(id));
                          }
                        }
                      }
                    });

                  case 7:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          })));
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGroupChange", function (groupId, group) {
      var translate = _this.props.translate;

      if (group != null) {
        _this.props.toggleSelectedSection(group, true);
      }

      if (groupId != 0) {
        _this.setState({
          sectionId: groupId
        }, function () {
          _this.props.getSection(groupId).then(function () {
            var _assertThisInitialize, _assertThisInitialize2;

            if (_this.props.section.students != null && _this.props.section.students.length == 0) {
              swal.fire({
                title: _this.props.translate('The group contains no students'),
                showCloseButton: true,
                confirmButtonText: _this.props.translate('Ok'),
                html: "\n\t\t\t\t\t\t\t".concat(translate('The group you selected does not contain any students. You can`t create assignments for a group without students. The group may lack students due to the fact that:'), "\n\t\t\t\t\t\t\t<br />\n\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t<li>").concat(translate('No students have been added to the group. Make sure your team/Microsoft 365 group includes students.'), "</li>\n\t\t\t\t\t\t\t\t<li>").concat(translate('Students have not been activated on the team. To do this, use Microsoft Teams.'), "</li>\n\t\t\t\t\t\t\t\t<li>").concat(translate('The group could not be loaded correctly. Close the form and reload the page, then try again.'), "</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t<br />\n\t\t\t\t\t\t\t")
              });

              _this.setState({
                sectionId: 0
              });

              return false;
            }

            _this.props.getPlansBySectionId(groupId);

            if ((_assertThisInitialize = _assertThisInitialized(_this)) !== null && _assertThisInitialize !== void 0 && (_assertThisInitialize2 = _assertThisInitialize.props) !== null && _assertThisInitialize2 !== void 0 && _assertThisInitialize2.displayTitle) {
              _this.props.displayTitle(group.title);
            }
          });
        });
      } else {
        _this.setState({
          sectionId: 0
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onPlanChange", function (event, form) {
      if (event.target.value != '0') {
        _this.setState({
          planid: event.target.value,
          loadingPlan: true
        });

        _this.props.getPlanDetails(event.target.value).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var _form$getFieldState, assessmentBlocks, values;

          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return _this.props.getBlocksByReference(event.target.value, 'PLAN');

                case 2:
                  if (_this.props.planBlocks != null) {
                    assessmentBlocks = _this.props.planBlocks.filter(function (block) {
                      return block.type == 'Haldor.Blocks.AssessmentBlock';
                    }).map(function (block) {
                      return _objectSpread(_objectSpread({}, block), {}, {
                        id: 0,
                        referenceId: 0,
                        referenceType: ''
                      });
                    });
                    values = (_form$getFieldState = form.getFieldState('assessmentBlocks')) === null || _form$getFieldState === void 0 ? void 0 : _form$getFieldState.value;

                    if (values == null) {
                      values = _toConsumableArray(assessmentBlocks);
                    } else {
                      values = [].concat(_toConsumableArray(values), _toConsumableArray(assessmentBlocks));
                    }

                    form.change('assessmentBlocks', values);
                  }

                  _this.setState({
                    loadingPlan: false
                  });

                case 4:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        })));
      } else {
        _this.props.setActivePlan(null);

        _this.setState({
          loadingPlan: true,
          planid: 0
        }, function () {
          _this.setState({
            loadingPlan: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (dates) {
      _this.setState({
        dateStart: dates.start,
        dateEnd: dates.end,
        allowFetch: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectDocument", function (files) {
      _this.setState({
        newDocuments: files
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeInstruction", function (instruction, remove) {
      var attachedFiles = _this.state.attachedFiles;
      var removeFile = attachedFiles.find(function (file) {
        return file.value == instruction;
      });

      if (removeFile != null) {
        if (_this.props.cloneView) {
          attachedFiles = attachedFiles.filter(function (t) {
            return t.value != instruction;
          });
        } else {
          if (removeFile.markedForDeletion == true && remove == false) {
            var removeFileIndex = attachedFiles.findIndex(function (file) {
              return file.value == instruction;
            });
            attachedFiles.splice(removeFileIndex, 1);
          }
        }
      } else {
        if (remove) {
          var assignmentDocuments = _this.props.initialValues ? _this.props.initialValues.assignmentDocuments != null ? _this.props.initialValues.assignmentDocuments.split(";") : [] : [];
          assignmentDocuments.forEach(function (document) {
            if (document == instruction && document != "" && document != null) {
              var _removeFile = {
                markedForDeletion: remove,
                fileType: 1,
                value: document,
                key: ''
              };
              attachedFiles.push(_removeFile);
            }
          });
        } else {
          var file = {
            fileType: 1,
            value: instruction,
            key: instruction.substring(instruction.lastIndexOf('/') + 1)
          };
          attachedFiles.push(file);
        }
      }

      _this.setState({
        attachedFiles: attachedFiles
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeTemplate", function (template, remove) {
      var attachedFiles = _this.state.attachedFiles;
      var removeFile = attachedFiles.find(function (file) {
        return file.value == template;
      });

      if (removeFile != null) {
        if (_this.props.cloneView) {
          attachedFiles = attachedFiles.filter(function (t) {
            return t.value != template;
          });
        } else {
          if (removeFile.markedForDeletion == true && remove == false) {
            var removeFileIndex = attachedFiles.findIndex(function (file) {
              return file.value == template;
            });
            attachedFiles.splice(removeFileIndex, 1);
          }
        }
      } else {
        if (remove) {
          var documentTemplates = _this.props.initialValues ? _this.props.initialValues.documentTemplates != null ? _this.props.initialValues.documentTemplates.split(';') : [] : [];
          documentTemplates.forEach(function (document) {
            if (document == template && document != '' && document != null) {
              var _removeFile2 = {
                markedForDeletion: remove,
                fileType: 2,
                value: document,
                key: ''
              };
              attachedFiles.push(_removeFile2);
            }
          });
        } else {
          var file = {
            fileType: 2,
            value: template,
            key: template.substring(template.lastIndexOf('/') + 1)
          };
          attachedFiles.push(file);
        }
      }

      _this.setState({
        attachedFiles: attachedFiles
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref5) {
      var input = _ref5.input,
          label = _ref5.label,
          type = _ref5.type,
          placeholder = _ref5.placeholder,
          _ref5$meta = _ref5.meta,
          touched = _ref5$meta.touched,
          error = _ref5$meta.error,
          warning = _ref5$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({
        placeholder: placeholder || label,
        type: type,
        style: touched && error ? {
          border: '1px solid red'
        } : {}
      }, input)), touched && (error && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '1rem',
          color: 'red'
        }
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '1rem',
          color: 'red'
        }
      }, warning)));
    });

    var _attachedFiles = [];

    var _dateStart = Moment().second(0);

    var dueDate = null;

    if (props.date != null) {
      _dateStart = props.date;
    }

    if ((_props$initialValues = props.initialValues) !== null && _props$initialValues !== void 0 && _props$initialValues.startDate) {
      var _props$initialValues2;

      _dateStart = Moment.utc((_props$initialValues2 = props.initialValues) === null || _props$initialValues2 === void 0 ? void 0 : _props$initialValues2.startDate).local();
    }

    if ((_props$initialValues3 = props.initialValues) !== null && _props$initialValues3 !== void 0 && _props$initialValues3.dueDate) {
      var _props$initialValues4;

      dueDate = (_props$initialValues4 = props.initialValues) === null || _props$initialValues4 === void 0 ? void 0 : _props$initialValues4.dueDate;
    }

    var _published = ((_props$initialValues5 = props.initialValues) === null || _props$initialValues5 === void 0 ? void 0 : _props$initialValues5.published) !== '0001-01-01T00:00:00' ? Moment.utc(props === null || props === void 0 ? void 0 : (_props$initialValues6 = props.initialValues) === null || _props$initialValues6 === void 0 ? void 0 : _props$initialValues6.published).local() : Moment().local();

    _this.inititalPublished = _published;
    _this.state = {
      dateStart: props.hasDate ? Moment(props.hasDate) : _dateStart,
      dateEnd: dueDate,
      sectionId: '0',
      tasks: null,
      attachedFiles: _attachedFiles,
      newDocuments: [],
      loading: false,
      updated: false,
      createEvent: false,
      published: _published,
      tempPublishDate: _published,
      allowFetch: true,
      lesson: [],
      status: (_props$initialValues$ = (_props$initialValues7 = props.initialValues) === null || _props$initialValues7 === void 0 ? void 0 : _props$initialValues7.status) !== null && _props$initialValues$ !== void 0 ? _props$initialValues$ : 'ASSIGNMENT_OPEN',
      isFetchingLesson: false,
      selectedLesson: [],
      toggleLesson: {},
      planid: props.planid != null ? props.planid : 0,
      fileTypes: [{
        value: 1,
        text: _this.props.translate('instructions')
      }, {
        value: 2,
        text: _this.props.translate('template-document')
      }]
    };
    return _this;
  }

  _createClass(AssignmentForm, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (window.location.pathname.indexOf('/plan/') == -1) {
        this.props.setActivePlan();
      }

      if (this.props.cloneView && this.props.clearOnUnmount) {
        this.props.setActiveAssignment();
      }

      this.props.setActiveSection(); // clear active section

      this.props.clearSelectedSections();
      this.props.clearSearchedSchedules();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.cloneView && nextProps.initialValues != null && this.state.updated == false) {
        var attachedFiles = this.state.attachedFiles;

        if (nextProps.initialValues.assignmentDocuments != null) {
          var files = nextProps.initialValues.assignmentDocuments.split(';');
          files.forEach(function (file) {
            if (file != '') {
              var fileObj = {
                key: file.substring(file.lastIndexOf('/') + 1),
                value: file,
                fileType: 1
              };
              attachedFiles.push(fileObj);
            }
          });
        }

        if (nextProps.initialValues.documentTemplates != null) {
          var files = nextProps.initialValues.documentTemplates.split(';');
          files.forEach(function (file) {
            if (file != '') {
              var fileObj = {
                key: file.substring(file.lastIndexOf('/') + 1),
                value: file,
                fileType: 2
              };
              attachedFiles.push(fileObj);
            }
          });
        }

        if (attachedFiles.length > 0) {
          this.setState({
            attachedFiles: attachedFiles,
            updated: true
          });
        }
      }
    }
  }, {
    key: "isIframe",
    value:
    /* Component methods and events */
    function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "render",
    value:
    /* Render form */
    function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          sectionId = _this$state2.sectionId,
          attachedFiles = _this$state2.attachedFiles;
      var isEditing = this.props.editView;
      var groupId = null;

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      var invalidDocuments = _toConsumableArray(this.state.newDocuments).filter(function (file) {
        if (file.fileType != null) {
          return file.fileType == 0;
        }

        return false;
      });

      var documentsPassing = true;

      if (invalidDocuments.length > 0) {
        documentsPassing = false;
      }

      if (this.state.sectionId != '0') {
        groupId = this.state.sectionId;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container form-create_task"
      }, /*#__PURE__*/React.createElement(InvalidGroupNotice, null), /*#__PURE__*/React.createElement(Form, {
        onSubmit: this.submit,
        initialValues: this.props.initialValues,
        initialValuesEqual: function initialValuesEqual() {
          return true;
        },
        mutators: {
          setStatusDraft: function setStatusDraft(args, state, utils) {
            utils.changeValue(state, 'status', function () {
              return 'ASSIGNMENT_DRAFT';
            });
          }
          /* 	setStatusOpen: (args, state, utils) => {
          	utils.changeValue(state, 'status', () => 'ASSIGNMENT_OPEN');
          }, */

        },
        render: function render(_ref6) {
          var _form$getFieldState2, _this2$props$lesson, _this2$props$lesson2, _this2$props$lesson3, _this2$props$lesson4, _this2$props$lesson5, _this2$props, _this2$props2, _this2$props3, _this2$props$initialV, _this2$props$initialV2;

          var handleSubmit = _ref6.handleSubmit,
              submitting = _ref6.submitting,
              valid = _ref6.valid,
              form = _ref6.form,
              initialValues = _ref6.initialValues;
          var statusValue = initialValues === null || initialValues === void 0 ? void 0 : initialValues.status;

          if (form.getFieldState('status') != null) {
            statusValue = form.getFieldState('status').value;
          }

          var assessmentBlocks = (_form$getFieldState2 = form.getFieldState('assessmentBlocks')) === null || _form$getFieldState2 === void 0 ? void 0 : _form$getFieldState2.value;
          var subjects = [];

          if ((assessmentBlocks === null || assessmentBlocks === void 0 ? void 0 : assessmentBlocks.length) > 0) {
            assessmentBlocks === null || assessmentBlocks === void 0 ? void 0 : assessmentBlocks.forEach(function (content) {
              var _content$resources;

              content === null || content === void 0 ? void 0 : (_content$resources = content.resources) === null || _content$resources === void 0 ? void 0 : _content$resources.forEach(function (resources) {
                if ((resources === null || resources === void 0 ? void 0 : resources.value) != null) {
                  var _resources$value;

                  if (subjects.indexOf((_resources$value = resources.value) === null || _resources$value === void 0 ? void 0 : _resources$value.subjectId) == -1) {
                    var _resources$value2;

                    subjects.push(parseInt((_resources$value2 = resources.value) === null || _resources$value2 === void 0 ? void 0 : _resources$value2.subjectId));
                  }
                }
              });
            });
          }

          return /*#__PURE__*/React.createElement("form", {
            onSubmit: handleSubmit,
            className: "form form-component"
          }, submitting ? /*#__PURE__*/React.createElement("div", {
            className: "is_sending"
          }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
            className: "loading-spinner"
          }))) : null, !isEditing ? /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement(GroupSelector, {
            disabled: _this2.props.groupid && _this2.props.cloneView == false ? true : false,
            onChange: _this2.onGroupChange,
            required: true,
            sectionId: _this2.state.sectionId
          })) : null, /*#__PURE__*/React.createElement("div", {
            className: "form-row select"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('Status')), /*#__PURE__*/React.createElement("select", {
            onChange: function onChange(e) {
              return _this2.handleStatus(e.target.value);
            },
            value: _this2.state.status
          }, _this2.props.assignmentStatus.filter(function (x) {
            return x.id !== 'ASSIGNMENT_DRAFT';
          }).map(function (item) {
            return /*#__PURE__*/React.createElement("option", {
              key: item.id,
              value: item.id
            }, item.id === 'ASSIGNMENT_CLOSED' ? _this2.props.translate('Hidden') : item.value);
          }))), /*#__PURE__*/React.createElement("div", {
            className: "form-row select"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('type'), "*"), /*#__PURE__*/React.createElement(Field, {
            component: "select",
            name: "assignmentType",
            validate: _this2.required
          }, /*#__PURE__*/React.createElement("option", {
            value: ""
          }, _this2.props.translate('select-an-alternative')), _this2.props.assignmentTypes.map(function (item) {
            return /*#__PURE__*/React.createElement("option", {
              key: item.id,
              value: item.id
            }, item.value);
          }))), /*#__PURE__*/React.createElement("div", {
            className: "form-row input"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('title'), "*"), /*#__PURE__*/React.createElement(Field, {
            component: _this2.renderInput,
            type: "text",
            name: "title",
            placeholder: _this2.props.translate('title'),
            validate: _this2.required
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-row input"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('description')), /*#__PURE__*/React.createElement(Field, {
            component: Editor,
            name: "description",
            placeholder: _this2.props.translate('describe-assignment'),
            translate: _this2.props.translate
          })), !isEditing && !_this2.props.disablePlanSelector ? /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('planning')), _this2.props.sectionPlans !== null ? /*#__PURE__*/React.createElement(Select, {
            dataType: "assignment-plan",
            placeholder: _this2.props.translate('pick-a-plan'),
            placeholderValue: null,
            disabled: _this2.props.planid && _this2.props.cloneView == false ? true : false,
            selectedValue: _this2.state.planid,
            options: _this2.props.sectionPlans,
            onChange: function onChange(e) {
              return _this2.onPlanChange(e, form);
            }
          }) : /*#__PURE__*/React.createElement(Select, {
            dataType: "assignment-plan",
            placeholder: _this2.props.translate('pick-a-plan'),
            placeholderValue: "",
            disabled: _this2.props.planid ? true : false,
            selectedValue: _this2.state.planid,
            options: [],
            onChange: function onChange(e) {
              return _this2.onPlanChange(e, form);
            }
          })) : null, /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement(DatePickerFromTo, {
            timePicker: true,
            type: "assignment",
            onChange: _this2.onDateChange,
            values: {
              startDate: _this2.state.dateStart,
              dueDate: _this2.state.dateEnd
            },
            cloneView: _this2.props.cloneView
          })), _this2.props.services.advancedSchedule ? /*#__PURE__*/React.createElement("div", {
            className: "form-row select"
          }, /*#__PURE__*/React.createElement("div", {
            className: "lesson-picker"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('select lesson')), /*#__PURE__*/React.createElement(CustomSelector, {
            label: _this2.props.lesson ? /*#__PURE__*/React.createElement("div", {
              className: "selectorLabel"
            }, /*#__PURE__*/React.createElement("span", {
              className: "selectorItems"
            }, (_this2$props$lesson = _this2.props.lesson) !== null && _this2$props$lesson !== void 0 && _this2$props$lesson.startTime ? Moment((_this2$props$lesson2 = _this2.props.lesson) === null || _this2$props$lesson2 === void 0 ? void 0 : _this2$props$lesson2.startTime).format('dddd Do MMMM') : _this2.props.time.format('dddd Do MMMM'), ' ', (_this2$props$lesson3 = _this2.props.lesson) !== null && _this2$props$lesson3 !== void 0 && _this2$props$lesson3.startTime ? Moment.utc((_this2$props$lesson4 = _this2.props.lesson) === null || _this2$props$lesson4 === void 0 ? void 0 : _this2$props$lesson4.startTime).set({
              second: 0,
              millisecond: 0
            }).local().format('LT') : _this2.props.time.format('LT'), "-", ' ', (_this2$props$lesson5 = _this2.props.lesson) !== null && _this2$props$lesson5 !== void 0 && _this2$props$lesson5.startTime ? Moment.utc(_this2.props.lesson.startTime).set({
              second: 0,
              millisecond: 0
            }).local().add(_this2.props.lesson.length, 'minutes').format('LT') : Moment.utc((_this2$props = _this2.props) === null || _this2$props === void 0 ? void 0 : _this2$props.time).set({
              second: 0,
              millisecond: 0
            }).local().add((_this2$props2 = _this2.props) === null || _this2$props2 === void 0 ? void 0 : _this2$props2.end, 'minutes').format('LT')), /*#__PURE__*/React.createElement("span", {
              className: "selectorItems"
            }, (_this2$props3 = _this2.props) === null || _this2$props3 === void 0 ? void 0 : _this2$props3.lesson.title)) : _this2.state.selectedLesson.length > 1 ? /*#__PURE__*/React.createElement("span", null, _this2.state.selectedLesson.length, ' ', _this2.props.translate('lessons selected')) : _this2.state.selectedLesson.length === 1 ? /*#__PURE__*/React.createElement("div", {
              className: "selectorLabel"
            }, /*#__PURE__*/React.createElement("span", {
              className: "selectorItems"
            }, Moment.utc(_this2.state.selectedLesson[0].startTime).local().format('dddd Do MMMM'), ' ', Moment.utc(_this2.state.selectedLesson[0].startTime).set({
              second: 0,
              millisecond: 0
            }).local().format('LT'), ' ', "-", ' ', Moment.utc(_this2.state.selectedLesson[0].startTime).local().add(_this2.state.selectedLesson[0].length, 'minutes').format('LT')), /*#__PURE__*/React.createElement("span", {
              className: "selectorItems"
            }, _this2.state.selectedLesson[0].title)) : /*#__PURE__*/React.createElement("span", null, _this2.props.translate('select lesson')),
            lesson: _this2.props.lesson,
            fetchLesson: _this2.fetchLesson
          }, !_this2.state.isFetchingLesson ? _this2.state.lesson.length === 0 ? /*#__PURE__*/React.createElement("div", {
            className: "noLesson"
          }, /*#__PURE__*/React.createElement("span", null, _this2.props.translate('There are no lessons within the assignment time period'))) : _this2.state.lesson.map(function (lesson) {
            return /*#__PURE__*/React.createElement("div", {
              key: lesson.id,
              tabIndex: 0
            }, /*#__PURE__*/React.createElement(Checkbox, {
              value: _this2.state.toggleLesson[lesson.id],
              onChange: function onChange(checked) {
                return _this2.handleLessons(checked, lesson);
              },
              label: /*#__PURE__*/React.createElement("div", null, Moment(lesson.startTime).format('dddd Do MMMM'), ' ', Moment.utc(lesson.startTime).local().set({
                second: 0,
                millisecond: 0
              }).format('LT'), ' ', "-", ' ', Moment.utc(lesson.startTime).local().set({
                second: 0,
                millisecond: 0
              }).add(lesson.length, 'minutes').format('LT'), ' ', lesson.title)
            }));
          }) : /*#__PURE__*/React.createElement(Spinner, {
            center: true
          })))) : null, /*#__PURE__*/React.createElement("div", {
            style: {
              clear: 'both'
            }
          }), _this2.props.services.advancedSchedule ? /*#__PURE__*/React.createElement("div", {
            className: "form-row",
            style: {
              marginBottom: '1rem'
            }
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('publication date')), /*#__PURE__*/React.createElement(Button, {
            type: "dropDown",
            onClick: function onClick(e) {
              return _this2.handleDisplayInSchedule(e);
            }
          }, _this2.state.published.format('dddd Do MMMM'), ' ', _this2.state.published.format('LT'))) : null, (_this2.props.editView || _this2.props.cloneView) && initialValues.assignmentDocuments !== null && initialValues.assignmentDocuments.length > 0 ? /*#__PURE__*/React.createElement("div", {
            className: "form-row",
            style: {
              marginBottom: '1em',
              width: '100%'
            }
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('instructions')), /*#__PURE__*/React.createElement(AttachedDocuments, {
            documents: initialValues.assignmentDocuments,
            removeInstruction: _this2.removeInstruction
          })) : null, _this2.props.cloneView && initialValues.documentTemplates !== null && initialValues.documentTemplates.length > 0 ? /*#__PURE__*/React.createElement("div", {
            className: "form-row",
            style: {
              marginBottom: '1em',
              width: '100%'
            }
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('templates')), /*#__PURE__*/React.createElement(AttachedDocuments, {
            documents: initialValues.documentTemplates,
            removeInstruction: _this2.removeTemplate
          })) : null, /*#__PURE__*/React.createElement("div", {
            className: "form-divider"
          }), /*#__PURE__*/React.createElement(Expandable, {
            title: _this2.props.translate('Assessments')
          }, !_this2.state.loadingPlan ? /*#__PURE__*/React.createElement(Field, {
            component: BlockAssessments,
            name: "assessmentBlocks",
            multipleAssessmentOptions: !_this2.props.editView ? false : !((_this2$props$initialV = _this2.props.initialValues) !== null && _this2$props$initialV !== void 0 && _this2$props$initialV.groupEnabled),
            assessmentFeedbackParts: _this2.props.cloneView ? null : _this2.props.assessments.reduce(function (prev, current, index) {
              var _this2$props$assessme, _this2$props$assessme2;

              return [].concat(_toConsumableArray(prev), _toConsumableArray((_this2$props$assessme = _this2.props.assessments[index]) === null || _this2$props$assessme === void 0 ? void 0 : (_this2$props$assessme2 = _this2$props$assessme.assessmentFeedbacks) === null || _this2$props$assessme2 === void 0 ? void 0 : _this2$props$assessme2.map(function (feedback) {
                return feedback.assessmentBlockPartId;
              })));
            }, []),
            disableRows: _this2.props.cloneView ? null : _this2.props.assessments.reduce(function (prev, current, index) {
              var _this2$props$assessme3, _this2$props$assessme4;

              return [].concat(_toConsumableArray(prev), _toConsumableArray((_this2$props$assessme3 = _this2.props.assessments[index]) === null || _this2$props$assessme3 === void 0 ? void 0 : (_this2$props$assessme4 = _this2$props$assessme3.assessmentDetails) === null || _this2$props$assessme4 === void 0 ? void 0 : _this2$props$assessme4.map(function (detail) {
                return detail.assessmentBlockPartRowId;
              })));
            }, [])
          }) : null), /*#__PURE__*/React.createElement(Upload, {
            lockedStatus: _this2.state.status === 'ASSIGNMENT_LOCKED' ? true : false,
            onUpdate: _this2.selectDocument,
            attachedFiles: attachedFiles,
            form: "assignment"
          }), _this2.props.services.additionalAdjustments ? /*#__PURE__*/React.createElement(Expandable, {
            title: _this2.props.translate("additional-adjustments")
          }, /*#__PURE__*/React.createElement(TeacherAdjustments, {
            disableCommenting: true,
            groupId: groupId,
            subjects: subjects
          })) : null, /*#__PURE__*/React.createElement(Expandable, {
            open: true,
            ignorePropsUpdate: true,
            title: _this2.props.translate('assign-students') + '*'
          }, /*#__PURE__*/React.createElement(Field, {
            component: AssignmentTaskSelect,
            name: "tasks",
            section: _this2.props.section,
            copyMode: _this2.props.cloneView,
            groupEnabled: _this2.props.cloneView ? true : (_this2$props$initialV2 = _this2.props.initialValues) === null || _this2$props$initialV2 === void 0 ? void 0 : _this2$props$initialV2.groupEnabled,
            validate: _this2.requireAssignmentTasks
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-divider"
          }), /*#__PURE__*/React.createElement("div", {
            className: "form-row spacing submit"
          }, isEditing ? /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick(e) {
              e.preventDefault();
              form.submit();
            },
            type: "save",
            disabled: submitting || !valid || !documentsPassing
          }, _this2.props.translate('save')) : /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick(e) {
              e.preventDefault();
              form.submit();
            },
            type: "save",
            disabled: submitting || !valid || sectionId == '0' || !documentsPassing
          }, _this2.props.translate('publish')), isEditing && initialValues.published != '0001-01-01T00:00:00' ? null : /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick(e) {
              e.preventDefault();
              form.mutators.setStatusDraft();
              form.submit();
            },
            type: "secondary",
            disabled: submitting || !valid || sectionId == '0' || !documentsPassing
          }, _this2.props.translate('save-draft')), /*#__PURE__*/React.createElement("div", {
            className: "align-right"
          }, /*#__PURE__*/React.createElement(Button, {
            type: "secondary",
            onClick: function onClick(e) {
              e.preventDefault();

              _this2.props.onAbort(false);
            }
          }, _this2.props.translate('Cancel')))));
        }
      }), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.createEvent,
        onClose: this.closeModal,
        title: this.props.translate('add-date')
      }, /*#__PURE__*/React.createElement("div", {
        className: "in_scheduleFrom"
      }, /*#__PURE__*/React.createElement("div", {
        className: "timeStart_scheduleFrom"
      }, /*#__PURE__*/React.createElement("span", null, this.props.translate('start'), "*"), /*#__PURE__*/React.createElement(DatePicker, {
        selected: this.state.tempPublishDate,
        startDate: this.state.tempPublishDate,
        onChange: this.handleDisplayDate,
        popperPlacement: "bottom-end",
        positionFixed: true,
        popperModifiers: {
          preventOverflow: {
            enabled: true
          },
          positionFixed: false
        },
        selectsEnd: true,
        showWeekNumbers: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: ""
      })), /*#__PURE__*/React.createElement("div", {
        className: "time_scheduleFrom"
      }, /*#__PURE__*/React.createElement("span", null, this.props.translate('start-time'), "*"), /*#__PURE__*/React.createElement(TimePicker, {
        placeholder: this.props.translate('pick-start-time'),
        time: this.state.tempPublishDate,
        onChange: this.handleDisplayDate
      })), /*#__PURE__*/React.createElement("div", {
        className: "submitTime"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onSubmitDisplayDate
      }, this.props.translate('Save'))))));
    }
  }]);

  return AssignmentForm;
}(Component);

_defineProperty(AssignmentForm, "defaultProps", {
  disablePlanSelector: false
});

function mapStateToProps(state, ownProps) {
  var _ownProps$planningAss, _state$planning$activ, _state$planning$activ2;

  var initialValues = null;

  if (state.assignments.active_assignment != null) {
    initialValues = state.assignments.active_assignment;
  }

  if (state.Blocks.reference != null && initialValues != null) {
    var blocks = JSON.parse(JSON.stringify(state.Blocks.reference));
    initialValues.assessmentBlocks = blocks.filter(function (block) {
      return block.type == "Haldor.Blocks.AssessmentBlock";
    });
  } //handle current planningAssessments


  if ((ownProps === null || ownProps === void 0 ? void 0 : (_ownProps$planningAss = ownProps.planningAssessments) === null || _ownProps$planningAss === void 0 ? void 0 : _ownProps$planningAss.length) > 0) {
    if (initialValues === null) {
      initialValues = {};
    }

    var filteredAssessmentsBlocks = ownProps === null || ownProps === void 0 ? void 0 : ownProps.planningAssessments.filter(function (t) {
      return t.type === 'Haldor.Blocks.AssessmentBlock';
    });

    if (filteredAssessmentsBlocks.length > 0) {
      initialValues.assessmentBlocks = filteredAssessmentsBlocks;
    }
  } //handle previous planningAssessments


  if (((_state$planning$activ = state.planning.active_plan) === null || _state$planning$activ === void 0 ? void 0 : (_state$planning$activ2 = _state$planning$activ.blocks) === null || _state$planning$activ2 === void 0 ? void 0 : _state$planning$activ2.length) > 0 && ownProps.existingPlanningAssessments) {
    var _state$planning, _state$planning$activ3, _state$planning$activ4;

    if (initialValues === null) {
      initialValues = {};
    }

    initialValues.assessmentBlocks = state === null || state === void 0 ? void 0 : (_state$planning = state.planning) === null || _state$planning === void 0 ? void 0 : (_state$planning$activ3 = _state$planning.active_plan) === null || _state$planning$activ3 === void 0 ? void 0 : (_state$planning$activ4 = _state$planning$activ3.blocks) === null || _state$planning$activ4 === void 0 ? void 0 : _state$planning$activ4.filter(function (t) {
      return t.type === 'Haldor.Blocks.AssessmentBlock';
    });
  }

  if (ownProps.time != null) {
    if (initialValues === null) {
      initialValues = {};
    }

    initialValues.startDate = Moment(ownProps.time);
  }

  if (ownProps.length != null && initialValues.startDate != null) {
    if (initialValues === null) {
      initialValues = {};
    }

    initialValues.dueDate = Moment(initialValues.startDate).add(ownProps.length, 'minutes');
  }

  if (ownProps.lesson != null) {
    if (initialValues == null) {
      initialValues = {};
    }

    var lesson = JSON.parse(JSON.stringify(ownProps.lesson));

    if (ownProps.lesson.startTime != null) {
      initialValues.startDate = Moment.utc(lesson.startTime).local();
      initialValues.dueDate = Moment(initialValues.startDate).add(ownProps.lesson.length, 'minutes');
    }
  }

  return {
    initialValues: initialValues,
    assessments: state.assessments.assessments,
    user: state.user.currentUser,
    sections: state.sections.educationGroups,
    section: state.sections.activeSection,
    assignmentTypes: state.status.status.assignmentTypes,
    assignmentStatus: state.status.status.assignmentStatus,
    translate: translate(state.Languages.translations),
    newAssignment: state.assignments.newAssignment,
    services: state.Services.availableServices,
    connectedLessons: state.schedule.selectedLessons,
    usersSchedule: state.schedule.usersSchedule,
    sectionPlans: state.planning.sectionPlans,
    plan: state.planning.active_plan,
    planBlocks: state.Blocks.reference
  };
}

export default withRouter(connect(mapStateToProps, {
  createAssignment: createAssignment,
  updateAssignment: updateAssignment,
  addError: addError,
  getTaskDetails: getTaskDetails,
  setActiveAssignment: setActiveAssignment,
  deleteBlock: deleteBlock,
  getSection: getSection,
  toggleSelectedSection: toggleSelectedSection,
  clearSelectedSections: clearSelectedSections,
  setActiveSection: setActiveSection,
  getScheduleForUser: getScheduleForUser,
  clearSearchedSchedules: clearSearchedSchedules,
  getPlanDetails: getPlanDetails,
  getPlansBySectionId: getPlansBySectionId,
  setActivePlan: setActivePlan,
  clearSectionPlansFromStore: clearSectionPlansFromStore,
  getScheduleItems: getScheduleItems,
  getBlocksByReference: getBlocksByReference,
  updateBlocksOnReference: updateBlocksOnReference,
  createAssessmentBlock: createAssessmentBlock,
  updateAssessmentBlock: updateAssessmentBlock
})(AssignmentForm));